<template>
  <div>
    <select
      class="form-control"
      v-model="customField"
      @focus="handleSelection"
      @change="handleSelection"
    >
      <option
        value=""
        v-if="addTag"
      >
        {{ __('Não Importar') }}
      </option>

      <option
        :key="field.identifier"
        v-for="field in fields"
        :value="field.identifier"
      >
        {{ __(field.description) }}
      </option>

      <option
        v-if="addTag"
        value="add_tag"
      >
        {{ __('Adicionar tag') }}
      </option>

      <option
        value="new_custom_field"
      >
        {{ __('+ Novo') }}
      </option>
    </select>

    <TenantCustomFieldModal
      :open="showModal"
      @close="closeModal"
      :field-type="newFieldType"
    />
  </div>
</template>

<script>
export default {
  props: {
    fields: Array,
    selected: '',
    addTag: false,
    newFieldType: null,
  },

  data () {
    return {
      customField: this.selected,
      previousValue: this.selected,
      showModal: false,
    };
  },

  watch: {
    customField (newVal, oldVal) {
      if (newVal == 'new_custom_field') {
        this.showModal = true;

        return;
      }

      this.$emit('select', newVal);
    },

    selected (newVal, oldVal) {
      if (newVal != oldVal && newVal != 'new_custom_field') {
        this.customField = newVal;
      }
    },
  },

  methods: {
    handleSelection () {
      this.previousValue = this.customField;
    },

    closeModal (data) {
      if (data.stored) {
        this.fields.push(data.stored);

        this.customField = data.stored.identifier;

        this.handleSelection();
      }

      if (! data.stored) {
        this.customField = this.previousValue;
      }

      this.showModal = false;
    },
  },
};
</script>
